@if ((showBadge$ | async) && (trialActive$ | async)) {
  <div class="trial-indicator badge" [ngClass]="{ expiring: (trialExpiringSoon$ | async) }">
    {{ 'COMMON.TRIAL' | translate | uppercase }}
  </div>
  <div class="trial-indicator time-remaining-badge" [ngClass]="{ expiring: (trialExpiringSoon$ | async) }">
    {{ trialDaysRemaining$ | async }}
  </div>
}
